import { DateFieldInput_default } from "../DateField/DateFieldInput.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DatePicker/DatePickerInput.vue?vue&type=script&setup=true&lang.ts
var DatePickerInput_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DatePickerInput",
	props: {
		part: {
			type: null,
			required: true
		},
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DateFieldInput_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DatePicker/DatePickerInput.vue
var DatePickerInput_default = DatePickerInput_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DatePickerInput_default };
//# sourceMappingURL=DatePickerInput.js.map